import { Dispatch, SetStateAction } from "react";
import { Box, MenuItem, Select } from "@mui/material";
import SelectorChevron from "@/assets/icons/header/SelectorChevron";
import clsx from "clsx";
import { capitalizeObjectKeys } from "@/Dashboard/helpers/capitalizeObjectKeys";

const FranchiseSelectorIcon = (props: { className: string }) => {
	const isOpen = props.className.includes("MuiSelect-iconOpen");
	return (
		<SelectorChevron
			className={clsx("absolute right-0 -z-10 text-default", {
				"rotate-180": isOpen,
			})}
		/>
	);
};

interface IFranchiseSelectorProps {
	data: ReturnType<typeof capitalizeObjectKeys>;
	selectedIndex: number;
	setSelectedIndex: Dispatch<SetStateAction<number>>;
}
export function FranchiseSelector({ selectedIndex, setSelectedIndex, data }: Readonly<IFranchiseSelectorProps>) {
	return (
		<Box className="relative pt-0 !h-4">
			<Select
				value={selectedIndex}
				label="Franchise"
				onChange={(e) => setSelectedIndex(Number(e.target.value))}
				IconComponent={FranchiseSelectorIcon}
				className="-top-[5px] [&>fieldset]:hidden !text-[13.5px] !font-medium"
				MenuProps={{
					className: "!max-h-[200px]",
					anchorOrigin: {
						horizontal: "right",
						vertical: "bottom",
					},
					transformOrigin: {
						horizontal: "right",
						vertical: "top",
					},
					slotProps: {
						paper: {
							className: "pt-[7px] pb-[10px] mt-[5px] !shadow-menu-gray",
						},
					},
					MenuListProps: {
						className: "!px-0 !py-0",
					},
				}}
				inputProps={{
					className: "!font-montserrat !text-neutral-gray text-[13.5px]/[16.5px] !h-4 !p-0 !m-0 !pr-7",
				}}
				SelectDisplayProps={{
					className: "!p-0 !m-0",
				}}
			>
				{data?.map((item, i) => (
					<MenuItem
						key={item.franchise}
						value={i}
						className={clsx("!py-[5px] !px-3 !min-w-20 !text-[12px] !font-montserrat !font-medium !text-[#666]", {
							"!bg-gray-highlight !text-white": i === selectedIndex,
						})}
					>
						{item.franchise}
					</MenuItem>
				))}
			</Select>
		</Box>
	);
}
